import React, { memo } from 'react';
import OnCallBadgeIcon from '../../assets/images/on-call-badge-icon.svg';

import './OnCallBadge.scss';

const OnCallBadge = () => (
	<div className="on-call-badge">
		<span className="on-call-badge__icon">
			<img src={OnCallBadgeIcon} alt="on-call-badge-icon" />
		</span>
		<span className="on-call-badge__label">On Call</span>
	</div>
);

export default memo(OnCallBadge);
